import React, { Fragment } from 'react';
import { bool, string } from 'prop-types';
import { useDoxUploaderContext } from '../doxUploader';
import DoxUploadItem from './doxUploadItem';

const DoxUploadList = ({ layoutType, cancelAll }) => {

    const { fileQueue, isSignaturePageContext, primaryName } = useDoxUploaderContext()

    return (
        <div className='dox-upload-panel'>
            <div className='dox-scroll-container'>
                <div className='dox-upload-item-width'>
                    {fileQueue && fileQueue.map((f, i) =>
                        <DoxUploadItem key={`doc-${i}`} queuedFile={f} cancel={cancelAll} layoutType={layoutType} isSignaturePageContext={isSignaturePageContext} filerName={primaryName} />
                    )}
                </div>
            </div>
        </div>
    )
}

DoxUploadList.propTypes = {
    layoutType: string,
    cancelAll: bool
}

export default DoxUploadList